angular.module('app').controller('RefundCtrl', function($http, order, payment, $mdToast, $mdDialog) {
    "ngInject";

    var main = this;
    main.payment = payment;
    if(order.balance_due < 0) {
        main.total = -1 * order.balance_due;
    } else {
        main.total = payment.total;
    }

    main.save = function() {
        if(main.saving) {
            var alert = $mdToast.simple().textContent("Refund already in progress");
            $mdToast.show(alert);
            return;
        }

        main.saving = true;

        var data = {
            'total': main.total,
            'notes': main.notes
        }

        $http.post('/api/v1/admin/payment/' + payment.id + '/refund', data).then(
            function(response) {
                main.saving = false;
                if(response.data.message) {
                    var alert = $mdToast.simple().textContent(response.data.message);
                    payment.total = 0;
                } else {
                    order.payments.push(response.data);
                    var alert = $mdToast.simple().textContent("Payment refunded");
                }

                $mdToast.show(alert);
                $mdDialog.hide(response.data);
            },
            function() {
                main.saving = false;
            }
        );
    }
});
